import React, { Component } from "react";
var FontAwesome = require("react-fontawesome");
import styled from "styled-components";

export default class SocialIcons extends Component {
  render() {
    const socialData = [
      {
        name: "facebook",
        link: "https://www.facebook.com/Moon-Beyond-1683370475243357"
      },
      {
        name: "twitter",
        link: "https://twitter.com/moonbeyond_co/"
      },
      {
        name: "instagram",
        link: "https://www.instagram.com/moonbeyond/"
      },
      {
        name: "tumblr",
        link: "http://moon-beyond.tumblr.com/"
      }
    ];

    const Wrap = styled.div`
      display: inline-block;
      font-size: 22px;
      margin-bottom: 16px;
    `;

    const SocialLink = styled.a`
      margin: 0 50px 0 0 !important;
      &:last-child {
        margin: 0 !important;
      }
    `;

    const FontAwesomeIcon = styled(FontAwesome)`
      color: ${props =>
        this.props.light
          ? props.theme.colors.grey
          : props.theme.colors.black} !important;

      &:hover {
        color: ${props =>
          this.props.light ? props.theme.colors.white : ""} !important;
      }
    `;

    return (
      <Wrap>
        {socialData.map((a, i) => (
          <SocialLink key={i} target="_blank" href={a.link}>
            <FontAwesomeIcon name={a.name} />
          </SocialLink>
        ))}
      </Wrap>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SocialIcons/index.js